import {STATUS} from '@jobseeker/common-core/constants';
import {enqueueSnackbar} from 'notistack';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';
import {ResponseProfileV2} from './types';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/profile/`
);

const getProfile = async (sections: {
  pd?: boolean;
  we?: boolean;
  ed?: boolean;
  co?: boolean;
  ai?: boolean;
  atr?: boolean;
  rd?: boolean;
}): Promise<ResponseProfileV2> => {
  try {
    let fields = '';
    fields += sections.pd ? '1' : '0';
    fields += sections.we ? '1' : '0';
    fields += sections.ed ? '1' : '0';
    fields += sections.co ? '1' : '0';
    fields += sections.ai ? '1' : '0';
    fields += sections.atr ? '1' : '0';
    fields += sections.rd ? '1' : '0';

    const response: any = await axios.get(`v2?fields=${fields}`, {
      withCredentials: true,
      headers: {
        'Cache-Control': 'no-cache',
      },
    });
    if (response[STATUS] === 200) {
      return response?.data?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const updateProfile = async (
  profileUpdationParams: ResponseProfileV2,
  version = '',
  updatedBy?: number,
  updationMeta?: string,
  valueUpdated?: 0 | 1
): Promise<ResponseProfileV2> => {
  try {
    const queryParams = new URLSearchParams();
    if (updatedBy !== undefined) queryParams.set('updatedBy', String(updatedBy));
    if (updationMeta !== undefined) queryParams.set('updationMeta', updationMeta);
    if (valueUpdated !== undefined)
      queryParams.set('valueUpdated', String(valueUpdated));
    const queryString = queryParams.toString();
    const url = queryString ? `v2?${queryString}` : 'v2';

    const response: any = await axios.post(url, profileUpdationParams, {
      withCredentials: true,
      headers: {
        version,
      },
    });
    if (response[STATUS] === 200) {
      return response?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const skipProfesssion = async (): Promise<ResponseProfileV2> => {
  try {
    const response: any = await axios.post(
      'skipwork',
      {},
      {
        withCredentials: true,
      }
    );
    if (response[STATUS] === 200) {
      return response?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const profileService = {
  getProfile,
  updateProfile,
  skipProfesssion,
};

export default profileService;
